import { useEffect, useState } from "react"
import { BACKEND } from "../../config/configEnvs"
import axios from "axios"
import { toast } from "react-toastify"
import { GetStatusColor, TextColorQuotesStatus } from "../../utils/GetTextColor"
import LoadingScreen from "../ui/temp-screens/LoadingScreen"
import { CalculateFinalPriceTotal, CalculateFinalPriceTotalWithPagoUnico } from "../../utils/metadata/CalculatePriceTotal"
import { CalcularPrecioPais } from "../../utils/preciosPaises/calcularPrecioPais"
import { ObtenerMultiplicador } from "../../utils/preciosPaises/obtenerMultiplicador"

export const CotizacionBarraMetadata = ({query, activeAgency, paises, currencyExchanges, leadValue, lead}) => {

  const [loading, setLoading] = useState(false)
  const [serviciosCotizaciones, setserviciosCotizaciones] = useState([])

  const [services, setServices] = useState([])

  const page = 1
  const limit = 0

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setServices(response.data.docs)
    } catch (e) {
      toast.error("Error al cargar los datos: " + e);
    }
  }
  
  const pagosCotisExito = serviciosCotizaciones.filter((s) => s.cotizacion.estado === "Exito" && !s.cotizacion.comparativo).reduce((acc, obj) => {
    // Validar que currencyExchanges y paises estén disponibles
    if (!currencyExchanges || !Array.isArray(currencyExchanges) || currencyExchanges.length === 0) {
      return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, paises || [], 1);
    }
    if (!paises || !Array.isArray(paises) || paises.length === 0) {
      return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, [], 1);
    }
    const tipoCambio = currencyExchanges.find(ce => ce.moneda === obj.cotizacion.moneda)?.tipoCambio || 1;
    return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, paises, tipoCambio);
  }, 0);  

  const pagosCotisEspera = serviciosCotizaciones.filter((s) => s.cotizacion.estado === "En espera" && !s.cotizacion.comparativo).reduce((acc, obj) => {
    // Validar que currencyExchanges y paises estén disponibles
    if (!currencyExchanges || !Array.isArray(currencyExchanges) || currencyExchanges.length === 0) {
      return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, paises || [], 1);
    }
    if (!paises || !Array.isArray(paises) || paises.length === 0) {
      return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, [], 1);
    }
    const tipoCambio = currencyExchanges.find(ce => ce.moneda === obj.cotizacion.moneda)?.tipoCambio || 1;
    return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, paises, tipoCambio);
  }, 0);  

  const pagosCotisPerdido = serviciosCotizaciones.filter((s) => s.cotizacion.estado === "Perdido" && !s.cotizacion.comparativo).reduce((acc, obj) => {
    // Validar que currencyExchanges y paises estén disponibles
    if (!currencyExchanges || !Array.isArray(currencyExchanges) || currencyExchanges.length === 0) {
      return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, paises || [], 1);
    }
    if (!paises || !Array.isArray(paises) || paises.length === 0) {
      return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, [], 1);
    }
    const tipoCambio = currencyExchanges.find(ce => ce.moneda === obj.cotizacion.moneda)?.tipoCambio || 1;
    return acc + CalculateFinalPriceTotalWithPagoUnico(obj, services, obj.cotizacion, paises, tipoCambio);
  }, 0);


  const fetchCotizaciones = async () => {
    // const baseUrl = `${BACKEND}/api/pagosCotizaciones?depth=0`;
    const baseUrl = `${BACKEND}/api/serviciosCotizaciones?depth=0`;
  
    const queryParams = {
      page,
      limit,
    };
  
    let andFilters = [];

    if (activeAgency) {
      // Solo aplicar el filtro si hay un cliente (no lead)
      // Usamos OR para incluir cotizaciones de leads Y cotizaciones de clientes activos
      queryParams['where[or][0][cotizacion.cliente][exists]'] = false; // Incluir cotizaciones de leads
      queryParams['where[or][1][and][0][cotizacion.cliente][exists]'] = true; // Cotizaciones con cliente
      queryParams['where[or][1][and][1][cotizacion.cliente.activoAgencia][equals]'] = true; // Y cliente activo
    } else {
      // Si no está activo el filtro, mostrar todas las cotizaciones
      // (tanto de leads como de clientes)
    }
    
    // if (query.activeAgency) {
    //   andFilters.push({
    //     [`cotizacion.cliente.activoAgencia`]: {
    //       equals: true,
    //     }
    //   });
    // } else {
    //   andFilters.push({
    //     [`cotizacion.cliente.activoAgencia`]: {
    //       not_equals: true,
    //     }
    //   });
    // }
  
    // Fecha sobre cotizacion.{fechaFiltro}
    if (query.fechaInicio) {
      andFilters.push({
        [`cotizacion.${query.fechaFiltro}`]: {
          greater_than_equal: new Date(query.fechaInicio).toISOString(),
        }
      });
    }
    if (query.fechaFin) {
      andFilters.push({
        [`cotizacion.${query.fechaFiltro}`]: {
          less_than_equal: new Date(query.fechaFin).toISOString(),
        }
      });
    }
    if (query.vendedor.length > 0) {
      andFilters.push({
        [`cotizacion.cotizador`]: {
          in: query.vendedor,
        }
      });
    }
    if (query.cliente) {
      andFilters.push({
        [`cotizacion.cliente`]: {
          equals: query.cliente.id,
        }
      });
    }
    if (query.estado) {
      andFilters.push({
        [`cotizacion.estado`]: {
          equals: query.estado,
        }
      });
    }
    if (query.subEstado) {
      andFilters.push({
        [`cotizacion.subEstado`]: {
          equals: query.subEstado,
        }
      });
    }
    if (lead) {
      andFilters.push({[`cotizacion.lead.${leadValue}`]: {like: lead}});
    }
    if (andFilters.length > 0) {
      andFilters.forEach((filter, index) => {
        const field = Object.keys(filter)[0];
        const operator = Object.keys(filter[field])[0];
        const value = filter[field][operator];
  
        queryParams[`where[and][${index}][${field}][${operator}]`] = value;
      });
    }
  
    // Armamos la query string
    const queryString = new URLSearchParams(queryParams).toString();
  
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}?${queryString}`);
      setserviciosCotizaciones(response.data.docs);
    } catch (e) {
      toast.error("Error al cargar los datos: " + e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCotizaciones()
    getServices()
  }, [])

  useEffect(() => {
    fetchCotizaciones()
  }, [query, activeAgency])

  return (
    <div className="flex bg-gray-100 mt-0.5 py-1 mb-0.5 w-full gap-10 items-center justify-center">
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <span className="block text-xs font-medium text-gray-900">
            <span className={`${GetStatusColor("Exito", TextColorQuotesStatus)}`}>
              En éxito: 
            </span>
            {" "}
            S/.
            {" "}
            {pagosCotisExito.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2            
            })}
          </span>

          <span className="block text-xs font-medium text-gray-900">
            <span className={`${GetStatusColor("En espera", TextColorQuotesStatus)}`}>
              En espera: 
            </span>
            {" "}
            S/.
            {" "}
            {pagosCotisEspera.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2            
            })}
          </span>

          <span className="block text-xs font-medium text-gray-900">
            <span className={`${GetStatusColor("Perdido", TextColorQuotesStatus)}`}>
              Perdidos: 
            </span>
            {" "}
            S/.
            {" "}
            {pagosCotisPerdido.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2            
            })}
          </span>
        </>
      )}

    </div>
  )
}